// Simple localStorage-based auth utility for frontend landing page

export const saveUser = (email, name) => {
  localStorage.setItem("zerodha_user", JSON.stringify({ email, name }));
};

export const getUser = () => {
  const user = localStorage.getItem("zerodha_user");
  return user ? JSON.parse(user) : null;
};

export const isLoggedIn = () => {
  return !!localStorage.getItem("zerodha_user");
};

export const logout = () => {
  localStorage.removeItem("zerodha_user");
};

export const getDashboardUrl = () => {
  return "/dashboard";
};
